// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__239FH","box":"WorkspacesBox_box__12XKf","node":"WorkspacesBox_node__3TucP"};